import React from 'react';
import { getTemplate } from 'TRANSLATION';
const Content = getTemplate('hint/EntityUsPerson');

export default function EntityUsPerson() {
  return <Content />;
}
